import { PATIENT_STATUS } from "~/common/constants";

export const BASE_MEDICATION_PATH = "/medications";
export const BASE_LEAD_PATH = "/lead";

export const ROUTES = {
  leadPatientHome: `${BASE_LEAD_PATH}`,
  leadScreeningIntroScreen: `${BASE_LEAD_PATH}/screening/intro-screen`,
  leadIntakeIntroScreen: `${BASE_LEAD_PATH}/intake/intro-screen`,
  home: `/`,
  verification: `/verification`,
  completedCheckins: `/completed-checkins`,
  consultationTypeCompleted: "/:consultationType/completed",
  settings: "/settings",
  medications: `${BASE_MEDICATION_PATH}/medication-history`,
  requests: `${BASE_MEDICATION_PATH}/requests`,
  medicationDetails: "/medications/:id",
  login: "/login",
  signUp: "/signup",
  verifyEmail: "/verify-email",
  verifiedEmail: "/email-verified/:patientId",
  signUpNewPatient: "/signup/lead",
  consultationInactive: "/signup/lead/inactive-error",
  resetPassword: "/password-reset",
  forgotPassword: "/forgot-password",
  checkIn: "/checkIn/:id",
  screening: `${BASE_LEAD_PATH}/screening/:id`,
  screeningAlreadyCompleted: `${BASE_LEAD_PATH}/screening/completed`,
  startScreening: `${BASE_LEAD_PATH}/screening/:id/start`,
  acknowledgeConsent: `${BASE_LEAD_PATH}/consent`,
  payment: `${BASE_LEAD_PATH}/payment`,
  confirmPayment: `${BASE_LEAD_PATH}/confirm-payment`,
  notFound: "/not-found",
  internalError: "/internal-error",
  intake: `${BASE_LEAD_PATH}/intake/:id`,
  startIntake: `${BASE_LEAD_PATH}/intake/:id/start`,
  completeScreeningConsultation: "/consultation/screening",
  completeIntakeConsultation: "/consultation/intake",
  schedulingInstructions: `${BASE_LEAD_PATH}/scheduling-instructions`,
} as const;

export const MODAL_ROUTES = {
  successModal: "/successModal",
} as const;

export const homePathByPatientStatus = {
  [PATIENT_STATUS.active]: ROUTES.home,
  [PATIENT_STATUS.consultation]: ROUTES.leadPatientHome,
};
